<template>
  <s-page v-if="loaded">
    <template v-slot:lateral-panel>
      <s-lateral-panel :consistent="false">
        <v-container justify="space-between" class="pb-0">
          <v-row>
            <v-col cols="12">
              <span class="title">Planning</span>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-if="loaded && selectedSemaines[0]" class="pa-2 pt-0" color="white">
          <membres-checkbox-group
            v-model="selectedMembres"
            :group-title="service.nom"
            :membres="membres"
            :semaine="selectedSemaines[0]"
            expand
          />
        </v-container>
      </s-lateral-panel>
    </template>
    <template v-slot:main-panel>
      <s-main-panel color="white">
        <planning-week-picker v-model="selectedSemaines" :send-fetch-creneaux-request="false" />
        <planning-body
          :creneaux="creneaux"
          :jours-de-repos="[]"
          :semaines="selectedSemaines"
          :membres="sortedSelectedMembres"
          :jour_nuit="jour_nuit"
          :service="service"
          :affichage-impression="false"
          :montrer-heures-travailles="montrerHeuresTravailles"
        />
      </s-main-panel>
    </template>
  </s-page>
</template>

<script>
import MembresCheckboxGroup from '../../components/membre/membre-checkbox-group'
import planningBody from '@/components/planning/planning'
import planningWeekPicker from '../../components/planning/semainePicker/planning-semaine-picker'
import { mapActions, mapGetters } from 'vuex'
import { initialDataLoaded } from '@/store/modules/helpers'
import SMainPanel from '@/components/global/s-main-panel.vue'
import SLateralPanel from '@/components/global/s-lateral-panel.vue'
import SPage from '@/components/global/s-page.vue'

export default {
  name: 'service-virtuel-planning',
  components: {
    SPage,
    SLateralPanel,
    SMainPanel,
    MembresCheckboxGroup,
    planningBody,
    planningWeekPicker,
  },
  data() {
    return {
      menuVisible: false,
      selectedMembres: [],
      selectedSemaines: [],
      afficherJourDeReposData: false,
      fetchingJoursDeRepos: [],
      montrerHeuresTravailles: false,
      loadingTempsDeTravail: true,
      creneaux: [],
    }
  },
  computed: {
    ...initialDataLoaded,
    ...mapGetters({
      etablissement: 'application/getSelectedEtablissement',
      isInRole: 'security/isInRole',
      getISOWeekOfDate: 'calendrier/getISOWeekOfDate',
      getDateofISOWeek: 'calendrier/getDateOfISOWeek',
      getServiceById: 'service/getServiceById',
      getMembresByServiceId: 'membre/getMembresByServiceId',
      getJoursDeRepos: 'servicePlanning/getJoursDeRepos',
      getPlanningParameters: 'application/getPlanningParameters',
      currentDate: 'calendrier/getCurrentDate',
    }),

    etablissementId() {
      return this.etablissement.etablissementId
    },
    serviceId() {
      return parseInt(this.$route.params.serviceId, 10)
    },
    service() {
      return this.getServiceById(this.serviceId)
    },
    semaine() {
      return this.selectedSemaines[0] ? this.selectedSemaines[0].semaine : undefined
    },
    annee() {
      return this.selectedSemaines[0] ? this.selectedSemaines[0].annee : undefined
    },
    loaded() {
      return initialDataLoaded && this.service && this.membres && this.sortedSelectedMembres
    },
    jour_nuit: {
      get() {
        return this.getPlanningParameters.jour_nuit
      },
      set(_value) {
        this.setPlanningJourNuit(_value)
      },
    },
    membres() {
      let membres = []
      if (this.creneaux != null && this.creneaux.length > 0) {
        this.creneaux.forEach((c) => {
          if (this.neContientPasLeMembreId(membres, c.membre.membreId)) {
            membres.push(c.membre)
          }
        })
        return membres.sort(function (mA, mB) {
          return mA - mB
        })
      }
      return []
    },
    sortedSelectedMembres() {
      return [...this.selectedMembres].sort(function (mA, mB) {
        return mA - mB
      })
    },
  },
  methods: {
    ...mapActions({
      obtenirTempsDeTravailByServiceVirtuel: 'servicePlanning/obtenirTempsDeTravailByServiceVirtuel',
      setPlanningJourNuit: 'application/setPlanningJourNuit',
    }),
    neContientPasLeMembreId(_tableauDesMembres, _idATrouver) {
      for (const membre of _tableauDesMembres) {
        if (parseInt(membre.membreId) === parseInt(_idATrouver)) {
          return false
        }
      }

      return true
    },
    loadCreneaux() {
      this.loadingTempsDeTravail = true
      this.obtenirTempsDeTravailByServiceVirtuel({
        etablissementId: this.etablissementId,
        serviceId: this.serviceId,
        annee: this.annee,
        semaine: this.semaine,
      }).then((creneaux) => {
        console.log('loaded creneaux')
        this.creneaux = creneaux
        this.loadingTempsDeTravail = false
      })
    },
  },
  created() {
    this.selectedMembres = [...this.membres]
  },
  watch: {
    membres() {
      this.selectedMembres = [...this.membres]
    },
    semaine() {
      if (this.semaine && this.annee) {
        this.loadCreneaux()
      }
    },
    annee() {
      if (this.semaine && this.annee) {
        this.loadCreneaux()
      }
    },
  },
}
</script>
